<template>
	<component v-bind:is="currentPopup" :data="currentData"></component>
</template>

<script>
	export default {
		data() {
			return {
				currentPopup: null,
				popupStack: [],
				currentData: null
			}
		},
		mounted() {
			this.$root.$on('add-popup', (popup, data) => {
				this.popupStack.push({ popup, data });
				this.openNextPopup();
			});
			this.$root.$on('close-popup', (popup) => {
				this.$nextTick(() => {
					this.currentPopup = null;
					this.currentData = null;
					this.openNextPopup();
				});
			});
		},
		methods: {
			openNextPopup() {
				if (!this.currentPopup && this.popupStack.length > 0) {
					let item = this.popupStack.pop();
					this.$nextTick(() => {
						this.currentPopup = item.popup;
						this.currentData =  item.data;
					})
				}
			}
		}
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/modals/PopupStack.vue